import { ModalService } from 'src/app/services/modal/modal.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AppAlertService } from 'src/app/services/app-alert/app-alert.service';
import { PersonService } from 'src/app/services/person/person.service';
import { Person } from 'src/app/models/person';
import { UserService } from 'src/app/services/user/user.service';
import { UserStore } from 'src/app/@auth/user.store';

@Component({
  selector: 'app-person-form',
  templateUrl: './person-form.component.html',
  styleUrls: ['./person-form.component.scss'],
})
export class PersonFormComponent implements OnInit {

  firstName = this.fb.control('');
  lastName = this.fb.control('');
  circleForm = this.fb.control('');
  picture: File | null = null; // Store the selected picture file
  pictureUrl: string | null = null; // Store the uploaded picture URL

  @Input('person') person: Person;
  @Input('circle') circle: string;

  constructor(
    private fb: FormBuilder,
    private modalCtrl: ModalController,
    private personService: PersonService,
    private alertService: AppAlertService,
    private modalService: ModalService,
    private userStore: UserStore
  ) { }

  ngOnInit() {
    if (this.person){
      this.firstName = this.fb.control(this.person.firstName);
      this.lastName = this.fb.control(this.person.lastName);
      this.pictureUrl = this.person.picture;
    }
    console.log(this.circle)
    if (this.circle && !this.person) this.circleForm = this.fb.control(this.circle);
  }

  onPictureSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.picture = input.files[0];
      this.previewPicture();
      this.uploadPicture(); // Automatically upload the picture
    }
  }

  previewPicture() {
    if (this.picture) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.pictureUrl = e.target.result; // Preview the selected picture
      };
      reader.readAsDataURL(this.picture);
    }
  }

  async uploadPicture() {
    if (!this.picture) {
      this.alertService.showErrorAlert('Please select a picture to upload.');
      return;
    }

    try {
      const uploadToast = await this.alertService.showGeneralToast('Uploading picture...', 'bottom', 20000);
      const uploadedPicture = await this.personService.uploadPicture(this.picture, this.person);
      this.pictureUrl = uploadedPicture.url; // Update the picture URL with the uploaded file's URL
      this.alertService.showSuccessAlert('Picture uploaded successfully.');
      uploadToast.dismiss();

    } catch (error) {
      this.alertService.showErrorAlert('Failed to upload picture.');
    }
  }

  save() {
    if (!this.circleForm.value && !this.person) {
      return this.alertService.showErrorAlert('Circle needs to be selected');
    }

    const personData = {
      firstName: this.firstName.value,
      lastName: this.lastName.value,
      circle: this.circleForm.value || this.person?.circle,
      user: this.userStore.getUser().documentId,
    };

    if (!this.person) {
      this.personService.createPerson(personData)
        .then((person) => {
          this.alertService.showSuccessAlert('Created Successfully', 'bottom');
          this.dismiss();
          this.modalService.openPerson(person.documentId);
        })
        .catch((e) => {
          this.alertService.showErrorAlert('Failed to Save: ' + e?.message);
          this.dismiss();
        });
    } else {
      this.personService.editPerson(this.person.documentId, personData)
        .then(() => {
          this.alertService.showSuccessAlert('Saved Successfully', 'bottom');
          this.dismiss('saved');
        })
        .catch((e) => {
          this.alertService.showErrorAlert('Failed to Save: ' + e?.message);
          this.dismiss();
        });
    }
  }

  dismiss(data = null) {
    this.modalCtrl.dismiss({
      'dismissed': true,
      'data': data
    });
  }

  delete(){
    this.personService.deletePerson(this.person.documentId).then(()=>{
      this.alertService.showSuccessAlert("Deleted Successfully", "bottom")
      this.dismiss('deleted')
    }).catch((e)=>{
      this.alertService.showErrorAlert("Failed to Delete: " + e?.message)
      this.dismiss()
    })
  }

}
